export default __webpack_public_path__ + "static/media/timer.957678ec.svg";